import { render, staticRenderFns } from "./engAndTrans.vue?vue&type=template&id=a8a75de4&"
import script from "./engAndTrans.vue?vue&type=script&lang=js&"
export * from "./engAndTrans.vue?vue&type=script&lang=js&"
import style0 from "./engAndTrans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports